import { useEffect } from "react";
import { Resolver, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  IReviewFormModel,
  reviewFormDefaultValues,
  reviewFormSchema,
} from "../models/reviewFormModel";

interface IUseReviewFormProps {
  initialValues?: IReviewFormModel;
  onSubmit: (values: IReviewFormModel) => void;
}

export const useReviewForm = ({ initialValues, onSubmit }: IUseReviewFormProps) => {
  const form = useForm<IReviewFormModel>({
    defaultValues: initialValues ?? reviewFormDefaultValues,
    // The schema is typed against the model; the yup resolver widens its fields to optional.
    resolver: yupResolver(reviewFormSchema) as Resolver<IReviewFormModel>,
  });

  // The values can arrive after the first render (the client's saved review loads
  // later), so they re-seed the form whenever they change.
  const initialRating = initialValues?.rating;
  const initialComment = initialValues?.comment;
  useEffect(() => {
    form.reset({
      rating: initialRating ?? reviewFormDefaultValues.rating,
      comment: initialComment ?? reviewFormDefaultValues.comment,
    });
  }, [initialRating, initialComment, form]);

  const commentLength = form.watch("comment")?.length ?? 0;

  const handleSubmit = form.handleSubmit((values) => onSubmit(values));

  return { form, commentLength, handleSubmit };
};
